import React from 'react';


import './AboutMe.css'
import MainAbout from './MainAbout';
const AboutMe = () => {
    return (
        <>
      
               
                
            <div className="middleMainAbout">
                    <MainAbout ></MainAbout>
                   
            </div>

           


      
        </>
    );
};

export default AboutMe;